import React from "react";
import ExcelUploadMeal from "./ExcelUploadMeal";

const RenderExcelUpload = (props) => {
  const {
    placeholder,
    input: { value, onChange },
    disabled,
    id,
  } = props;
  return (
    <div>
      <ExcelUploadMeal
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default RenderExcelUpload;
